import gql from 'graphql-tag';

export const addNewsfeedMutation = gql`mutation insert_newsfeeds_one($object: newsfeeds_insert_input!){
  insert_newsfeeds_one(object:$object){
    id
  }
}`;

export const editNewsFeedcategoryMutation = gql`
  mutation UpdateNewsfeedStatus($id: uuid!, $categoryName: String!) {
    update_newsfeed_categories_by_pk(pk_columns: { id: $id }, _set: { category_name: $categoryName }) {
      id
      category_name
    }
  }
`;

export const updateNewsfeedStatusMutation = gql`
  mutation UpdateNewsfeedStatus($id: uuid!, $status: String!) {
    update_newsfeeds_by_pk(pk_columns: { id: $id }, _set: { status: $status }) {
      id
      status
    }
  }
`;

export const updateNewsfeedDataMutation = gql`
  mutation UpdateNewsfeed($id: uuid!, $data: newsfeeds_set_input!) {
    update_newsfeeds_by_pk(pk_columns: { id: $id }, _set: $data ) {
      id
      description
      category_type
      video_url
      post_image
      web_url
      user_role
      user_id
      status
      created_at
      updated_at
    }
  }
`;

export const deleteNewsfeedMutation = gql`
  mutation DeleteNewsfeed($id: uuid!) {
    delete_newsfeeds_by_pk(id: $id) {
      id
    }

     delete_comments_replies: delete_news_feeds_comments_replys(where: {news_feeds_id: {_eq: $id}}) {
      affected_rows
    }

  }
`;
export const deleteJobMutation = gql`
  mutation Deletejobs($id: uuid!) {
    delete_jobs_by_pk(id: $id) {
      id
    }
  }
`;
export const deleteLearnHubMutation = gql`
  mutation DeleteLaerningHub($id: uuid!) {
    delete_courses_by_pk(id: $id) {
      id
    }
  }
`;

export const getAllNewsfeeds = gql`
  query getAllNewsfeeds($where: newsfeeds_bool_exp!, $limit: Int, $offset: Int , $communityId: uuid) {
    newsfeeds(
      where: $where
      order_by: { created_at: desc }
      limit: $limit
      offset: $offset
    ) {
      id
      created_at
      updated_at
      post_image
      community_id
      description
      category_type
      attachments
      feed_type
      payload
      user_role
      video_url
      web_url
      user_id
      status
      title
      dental_practice_id
      dental_professional_id
      dental_supplier_id
      dental_admin_id
      dental_supplier {
        id
        logo
        business_name
        profession_type
        email
        phone
        name
        type
        directories {
          id
          company_name
          logo
          description
          banner_image
        }
      }
      dental_professional {
        id
        name
        profession_type
        profile_image
        email
        phone
        type
      }

      dental_practice {
        id
        logo
        business_name
        profession_type
        email
        phone
        name
        type
        directories {
          company_name
          logo
          description
          banner_image
        }
      }
      admin_user {
        id
        phone
        email
      }
      newsfeeds_likes {
        dental_admin_id
        admin_user {
          id
          name
        }
        dental_practice {
          id
          name
          logo
          type
          profession_type
           directories {
              id
              logo
            }
        }

        dental_supplier {
          id
          name
          logo
          type
          profession_type
           directories {
              id
              logo
            }
        }

        dental_professional {
          id
          name
          profession_type
          type
          profile_image
           directories {
              id
              logo
            }
        }
      }

      newsfeeds_likes_aggregate {
        aggregate {
          count
        }
      }

      news_feeds_comments(order_by: { created_at: desc }) {
        id
        comments
        created_at
        updated_at
        dental_admin_id
        comment_Pro_Img
        commenter_name
        comments_attachments

        comment_reply {
          id
          reply_text
          comment_id
          created_at
          reply_id
          reply_attachments
          dental_admin_id
          dental_practice_id
          dental_professional_id
          dental_supplier_id
          dental_supplier {
            name
            logo
            directories {
              id
              logo
            }
          }
          dental_practice {
            name
            logo
            directories {
              id
              logo
            }
          }
          dental_professional {
            name
            profile_image
            directories {
              id
              profile_image
            }
          }
          admin_user {
            name
            profile_image
          }

          newsfeeds {
            id
          }

          jobs {
            id
          }
          courses {
            id
          }
        }
        dental_practice_id
        dental_professional_id
        dental_supplier_id
        dental_supplier {
          name
          logo
          directories {
            id
            logo
          }
        }
        dental_practice {
          name
          logo
          directories {
            id
            logo
          }
        }
        dental_professional {
          name
          profile_image
          directories {
            id
            profile_image
          }
        }
        admin_user {
          name
          profile_image
        }

        newsfeed {
          id
        }

        jobs {
          id
        }
        courses {
          id
        }
      }

      news_feeds_comments_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`;

export const monthNewsFeedCountSubscription = gql`
  subscription monthNewsFeedCountSubscription($andList: [newsfeeds_bool_exp!]) {
    newsfeed_categories {
      id
      category_name
      newsfeeds_aggregate(where: {_and: $andList}) {
        aggregate {
          count
        }
      }
    }
  }

`;

export const getNewsfeedIdData = gql`
  query getAllNewsfeeds($id: uuid!) {
    newsfeeds(where: { id: { _eq: $id } }) {
      id
      created_at
      category_type
      feed_type
      user_id
      status
      dental_practice_id
      dental_professional_id
      dental_supplier_id
      dental_admin_id
      dental_supplier {
        id
        logo
        business_name
        profession_type
        email
        phone
        name
        type
        directories {
          id
          company_name
          logo
          description
          banner_image
        }
      }
      dental_professional {
        id
        name
        profession_type
        profile_image
        email
        phone
        type 
        directories {
        id
        }
      }

      dental_practice {
        id
        logo
        business_name
        profession_type
        email
        phone
        name
        type
        directories {
        id
          company_name
          logo
          description
          banner_image
        }
      }
      admin_user {
        id
        phone
        email
      }

    newsfeeds_likes {
      id
        dental_admin_id
        admin_user {
          id
          name
        }

        dental_practice {
          business_name
          directories {
            id
          }
        }

        dental_supplier {
          business_name
          directories {
            id
          }
        }

        dental_professional {
          name
          directories {
            id
          }
        }
      }

      newsfeeds_likes_aggregate {
        aggregate {
          count
        }
      }

      news_feeds_comments {
        id
        comments
        created_at
        dental_admin_id
        comment_Pro_Img
        commenter_name
        comments_attachments

        comment_reply {
          id
          reply_text
          comment_id
          created_at
          reply_id
          reply_attachments
          dental_admin_id
          dental_practice_id
          dental_professional_id
          dental_supplier_id
          dental_supplier {
            name
            logo
            business_name
            directories {
              id
              logo
            }
          }
          dental_practice {
            name
            logo
            business_name
            directories {
              id
              logo
            }
          }
          dental_professional {
            name
            profile_image
            directories {
              id
              profile_image
            }
          }
          admin_user {
            id
            name
            profile_image
          }

          newsfeeds {
            id
          }

          jobs {
            id
          }
            courses{
            id
            }
        }

        dental_practice_id
        dental_professional_id
        dental_supplier_id
        dental_supplier {
          name
          business_name
          logo
          directories {
            id
            logo
          }
        }
        dental_practice {
          name
          logo
          business_name
          directories {
            id
            logo
          }
        }
        dental_professional {
          name
          profile_image
          directories {
            id
            profile_image
          }
        }
        admin_user {
          id
          name
          profile_image
        }

        newsfeed {
          id
        }
        jobs {
          id
        }

        courses{
        id
        }
      }

      news_feeds_comments_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`;

export const getNewsfeedsCount = gql`
query getNewsfeeds($status: String!) {
    newsfeeds_aggregate(where: {status: {_eq: $status}}){
  
      aggregate{
        count
      }
     
    }
  }

`;
export const getJobsFeedsCount = gql`
  query getJobsFeedsCount($where: jobs_bool_exp!) {
    jobs_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

export const getLearningHubCount = gql`
  query getLearningHubCount($where: courses_bool_exp!) {
    courses_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

export const addNewsFeedLikes = gql`

mutation addNewsFeedLikes($addLikes: newsfeeds_likes_insert_input!) {
  insert_newsfeeds_likes_one(object: $addLikes) {
    id
  }
}

`;


export const addNewsFeedComments = gql`

mutation addNewsFeedComments($addCommentsData: news_feeds_comments_insert_input!) {
  insert_news_feeds_comments_one(object: $addCommentsData) {
    id
    comments
  }
}

`;

export const updateNewsfeedCommentMutation = gql`
  mutation UpdateNewsfeedComments($id: uuid!, $data: news_feeds_comments_set_input!) {
    update_news_feeds_comments_by_pk(pk_columns: { id: $id }, _set: $data ) {
      id
    }
  }
`;

export const updateNewsfeedReplyMutation = gql`
  mutation updateNewsfeedReply($id: uuid!, $data: news_feeds_comments_replys_set_input!) {
    update_news_feeds_comments_replys_by_pk(pk_columns: { id: $id }, _set: $data ) {
      id
    }
  }
`;

export const getCommentIdData = gql`
query getComments($id: uuid!){
  news_feeds_comments_by_pk(id:$id){
  id
  comments
}
}
`;

export const deleteNewsfeedCommentsMutation = gql`
  mutation DeleteNewsfeedComments($id: uuid!) {
  delete_news_feeds_comments_by_pk(id: $id) {
      id
    }   

  delete_news_feeds_comments_replys(where: {comment_id: {_eq: $id}}) {
      affected_rows
    }
  }
`;

export const deleteNewsfeedReplysMutation = gql`
  mutation deleteNewsfeedReply($id: uuid!) {
    delete_news_feeds_comments_replys_by_pk(id: $id) {
      id
    }
       delete_news_feeds_comments_replys(where: {reply_id: {_eq: $id}}) {
      affected_rows
  }
  }
`;


export const addNewsFeedCommentsReplys = gql`
mutation addNewsFeedCommentsReplys($addReplyData: news_feeds_comments_replys_insert_input!) {
  insert_news_feeds_comments_replys_one(object: $addReplyData) {
    id
    admin_user {
      id
      name
      email
      profile_image
    }
      dental_supplier{
          name
            logo
            directories{
              id
              logo
            }
          }
          dental_practice{
            name
            logo
            directories{
              id
              logo
            }
          }
          dental_professional{
            name
            profile_image
            directories{
              id
              profile_image
            }
          }
    comment_id
    reply_text
    news_feeds_id
    dental_supplier_id
    dental_professional_id
    dental_practice_id
    dental_admin_id
    liked_count
    reply_id
    reply_attachments
    jobs_id


  }
}
`;

export const removeNewsfeedLikes = gql`
mutation removeNewsfeedLikes($userId: uuid, $feedId: uuid) {
  delete_newsfeeds_likes(
    where: {
      _and: [
        {
          _or: [
            { dental_supplier_id: { _eq: $userId } },
            { dental_practice_id: { _eq: $userId } },
            { dental_professional_id: { _eq: $userId } },
            { dental_admin_id: { _eq: $userId } }
          ]
        },
        {
          _or: [
            { news_feeds_id: { _eq: $feedId } },
            { jobs_id: { _eq: $feedId } },
            { course_id: { _eq: $feedId } },
          ]
        }
      ]
    }
  ) {
    affected_rows
  }
}
`;





export const supplierInfo = gql`
query getSupplier($id: uuid!){
    dental_suppliers_by_pk(id:$id){
    id
    logo
    email
    name
    phone
    profile_image
    address
    type
    profession_type
    business_name
    profile_completed
    directoryFollowersByFollowerDentalSupplierId{
    following_status
    }
     directories{
         company_name
         banner_image
         	dental_practice_id
		dental_professional_id
		dental_supplier_id
    description
		designation
    education
		hobbies
    latitude
		longitude
		abn_acn
    working_at

  
         }
  }
}
`;

export const getCommentReplies = gql`
  query getCommentReplies {
    news_feeds_comments_replys {
      id
      reply_text
      comment_id
      reply_id
      reply_attachments
      dental_admin_id
      dental_practice_id
      dental_professional_id
      dental_supplier_id
      dental_supplier {
        name
      }

      newsfeeds {
        id
      }

      jobs {
        id
      }

    }
  }
`;

export const allbusinessInfo = gql`
query getSupplier($limit: Int, $offset: Int, $where: directory_followers_bool_exp) {
  dental_suppliers(limit: $limit, offset: $offset) {
    id
    email
    name
    phone
    logo
    address
    type

    profession_type
    directories{
    id
    }

    directoryFollowersByFollowerDentalSupplierId(where: $where) {
      following_status
    }
    newsfeeds {
      id
    }
  }
}
`;
// export const allbusinessInfo = gql`
// query getSupplier{
//     dental_suppliers{
//     id
//     email
//     name
//     phone
//     logo
//     address
//     type
//     profession_type
//     directoryFollowersByFollowerDentalSupplierId{
//     following_status
//     }
//     newsfeeds{
//     id
//     }

//   }
// }
// `;


export const practiceInfo = gql`
query getPractice($id: uuid!){
    dental_practices_by_pk(id:$id){
        id
        email
        logo
        name
        phone
        profile_image
        address
        profile_completed
    type
    profession_type
    business_name
    directoryFollowersByFollowerDentalPracticeId{
    following_status
    }
     directories{
         company_name
         banner_image
         	dental_practice_id
		dental_professional_id
		dental_supplier_id
    description
		designation
    education
		hobbies
    latitude
		longitude
		abn_acn
    working_at
         }
  }
}
`;
export const allpracticeInfo = gql`
query getPractice($limit: Int, $offset: Int, $where: directory_followers_bool_exp) {
  dental_practices(limit: $limit, offset: $offset) {
    id
    email
    name
    phone
    logo
    address
    type
    profession_type
    directoryFollowersByFollowerDentalPracticeId(where: $where) {
      following_status
    }
    directories {
      id
    }
    newsfeeds {
      id
    }
  }
}
`;

export const getCompanyById = gql`
  query GetCompanyById($id: uuid!) {
  directories(where: { id: { _eq: $id } }) {
    id
    name
    company_name
    email
    directoryFollowersByFollowerDentalCompanyId {
      following_status
    }
    logo
    type
  }
}

`;

export const professionalInfo = gql`
query getProfessional($id: uuid!){
    dental_professionals_by_pk(id:$id){
        id
        email
        name
        phone
        first_name
        last_name
        profile_image
        profile_completed
        address
    type
    profession_type
          directoryFollowersByFollowerDentalProfessionalId{
    following_status
    }
     directories{
         company_name
         banner_image
         	dental_practice_id
		dental_professional_id
		dental_supplier_id
    description
		designation
    education
		hobbies
    latitude
		longitude
		abn_acn
    working_at
         }
  }
}
`;


export const allprofessionalInfo = gql`
  query getProfessional($limit: Int!, $offset: Int!, $where: directory_followers_bool_exp) {
    dental_professionals(limit: $limit, offset: $offset) {
      id
      email
      name
      phone
      first_name
      last_name
      profile_image
      address
      type
      profession_type
      directoryFollowersByFollowerDentalProfessionalId(where: $where) {
        following_status
      }
        directories{
        id
        }
      newsfeeds {
        id
      }
    }
  }
`;
export const allcompanyInfo = gql`
query getCompany{
    directories{
        id
        name
        email
        logo
        profile_image
     company_name
    type
    profession_type
    directoryFollowersByFollowerDentalCompanyId{
    following_status
    }

  }
}
`;


export const getAllNewsfeedCategories = gql`
  query getAllNewsfeedCategories {
    newsfeed_categories(
    where: { community_id: { _is_null: true } } 
    order_by: { created_at: desc }
    ) {
        id
        category_name
        created_at
        updated_at
        created_by
        created_by_user_id
      }
   
  }
`;
export const getNewsfeedCategoriesByCommunity = gql`
  query getNewsfeedCategoriesByCommunity($communityId: uuid!) {
    newsfeed_categories(
      where: { community_id: { _eq: $communityId } },
      order_by: { created_at: desc }
    ) {
      id
      category_name
      created_at
      updated_at
      created_by
      created_by_user_id
      community_id
    }
  }
`;
export const addCategoryMutation = gql`mutation insert_newsfeed_categories_one($object: newsfeed_categories_insert_input!){
  insert_newsfeed_categories_one(object:$object){
    id
  }
}`;



export const deleteCategoriesMutation = gql`
  mutation DeleteNewsfeed($id: uuid!) {
    delete_newsfeed_categories_by_pk(id: $id) {
      id
    }
  }
`;

export const getNewsfeedsByUserId = gql`
  query GetNewsfeedsByUserId($userId: uuid!, $userRole: String!) {
    newsfeeds(
      where: {
        _or: [
          {user_id: {_eq: $userId}, user_role: {_eq: $userRole}},
          {dental_practice_id: {_eq: $userId}},
          {dental_professional_id: {_eq: $userId}},
          {dental_supplier_id: {_eq: $userId}},
          {dental_admin_id: {_eq: $userId}}
        ]
      },
      order_by: {created_at: desc}
    ) {
      id
      title
      description
      category_type
      status
      created_at

    }
  }
`;


export const getNewsfeedsByUserIds = gql`
  query GetNewsfeedsByUserIds(
  $userId: uuid!,
  $userRole: String!,
    $limit: Int,
    $offset: Int
  ) {
    newsfeeds(
      where: {
            status: { _eq: "PUBLISHED" },
             user_id: { _eq: $userId },
      user_role: { _eq: $userRole }
      },
      order_by: { created_at: desc },
      limit: $limit,
      offset: $offset
    ) {
      id
      title
      description
      category_type
      status
      created_at
    }
  }
`;


export const getNewsfeedsCategories = gql`
  query GetNewsfeedCategories {
    newsfeeds_categories {
      id
      category_name
    }
  }
`;

export const getFilteredNewsfeedsByCategory = gql`
  query GetFilteredNewsfeedsByCategory(
    $where: newsfeeds_bool_exp!
    $limit: Int!
    $offset: Int!
    $userId:uuid
    $roleType:String
  ) {
    newsfeeds(
      where: $where
      limit: $limit
      offset: $offset
      order_by: { updated_at: desc }
    ) {
      id
      created_at
      post_image
      description
      category_type
      attachments
      feed_type
      payload
      user_role
      video_url
      web_url
      user_id
      status
      title
      dental_practice_id
      dental_professional_id
      dental_supplier_id
      dental_admin_id

      dental_supplier {
        id
        logo
        business_name
        profession_type
        email
        phone
        name
        type
        directories {
          id
          company_name
          logo
          description
          banner_image
        }
      }

      dental_professional {
        id
        name
        profession_type
        profile_image
        email
        phone
        type
      }

      dental_practice {
        id
        logo
        business_name
        profession_type
        email
        phone
        name
        type
        directories {
          company_name
          logo
          description
          banner_image
        }
      }

      admin_user {
        id
        phone
        email
      }

     newsfeeds_likes {
      id
        dental_admin_id
        admin_user {
          id
          name
        }

        dental_practice {
          business_name
          directories {
            id
          }
        }

        dental_supplier {
          business_name
          directories {
            id
          }
        }

        dental_professional {
          name
          directories {
            id
          }
        }
      }

      my_like: newsfeeds_likes(
        where: {
          role_type: { _eq: $roleType }
          _or: [
            { dental_supplier_id: { _eq: $userId } }
            { dental_practice_id: { _eq: $userId } }
            { dental_professional_id: { _eq: $userId } }
            { dental_admin_id: { _eq: $userId } }
          ]
        }
      ) {
        id
      }

      newsfeeds_likes_aggregate {
        aggregate {
          count
        }
      }

      news_feeds_comments(order_by: { created_at: desc }) {
        id
        comments
        created_at
        dental_admin_id
        comment_Pro_Img
        commenter_name
        comments_attachments

        comment_reply {
          id
          reply_text
          comment_id
          created_at
          reply_id
          reply_attachments
          dental_admin_id
          dental_practice_id
          dental_professional_id
          dental_supplier_id

          dental_supplier {
            name
            logo
            directories {
              id
              logo
            }
          }

          dental_practice {
            name
            logo
            directories {
              id
              logo
            }
          }

          dental_professional {
            name
            profile_image
            directories {
              id
              profile_image
            }
          }

          admin_user {
            name
            profile_image
          }

          newsfeeds {
            id
          }

          jobs {
            id
          }
        }

        dental_practice_id
        dental_professional_id
        dental_supplier_id

        dental_supplier {
          name
          logo
          directories {
            id
            logo
          }
        }

        dental_practice {
          name
          logo
          directories {
            id
            logo
          }
        }

        dental_professional {
          name
          profile_image
          directories {
            id
            profile_image
          }
        }

        admin_user {
          name
          profile_image
        }

        newsfeed {
          id
        }
        jobs {
          id
        }
      }

      news_feeds_comments_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`;


export const getFilteredNewsfeedsCount = gql`
  query GetFilteredNewsfeedsCount($where: newsfeeds_bool_exp!) {
    newsfeeds_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`;


export const getCatalogueFeeds = gql`
  query GetCatalogueFeeds($where: newsfeeds_bool_exp!, $limit: Int!, $offset: Int!) {
    newsfeeds(
      where: $where
      order_by: { updated_at: desc }
      limit: $limit
      offset: $offset
    ) {
      id
      title
      community_id
      feed_type
      status
      user_id
      category_type
      payload
      user_role
      video_url
      web_url
      created_at
      dental_practice_id
      dental_professional_id
      dental_supplier_id
      dental_admin_id
      post_image
      dental_supplier {
        id
        logo
        business_name
        profession_type
        email
        phone
        name
        type
        directories {
          id
          company_name
          logo
          description
          banner_image
        }
      }

      dental_professional {
        id
        name
        profession_type
        profile_image
        email
        phone
        type
      }

      dental_practice {
        id
        logo
        business_name
        profession_type
        email
        phone
        name
        type
        directories {
          company_name
          logo
          description
          banner_image
        }
      }

      admin_user {
        id
        phone
        email
      }

      newsfeeds_likes {
        dental_admin_id
        admin_user {
          id
          name
        }
        dental_practice {
          id
          name
          logo
          type
          profession_type
           directories {
              id
              logo
            }
        }
        dental_supplier {
          id
          name
          logo
          type
          profession_type
           directories {
              id
              logo
            }
        }
        dental_professional {
          id
          name
          profession_type
          type
          profile_image
           directories {
              id
              logo
            }
        }
      }

      newsfeeds_likes_aggregate {
        aggregate {
          count
        }
      }

      news_feeds_comments(order_by: { created_at: desc }) {
        id
        comments
        created_at
        dental_admin_id
        comment_Pro_Img
        commenter_name
        comments_attachments

        comment_reply {
          id
          reply_text
          comment_id
          created_at
          reply_id
          reply_attachments
          dental_admin_id
          dental_practice_id
          dental_professional_id
          dental_supplier_id

          dental_supplier {
            name
            logo
            directories {
              id
              logo
            }
          }

          dental_practice {
            name
            logo
            directories {
              id
              logo
            }
          }

          dental_professional {
            name
            profile_image
            directories {
              id
              profile_image
            }
          }

          admin_user {
            name
            profile_image
          }

          newsfeeds {
            id
          }

          jobs {
            id
          }

        }

        dental_practice_id
        dental_professional_id
        dental_supplier_id

        dental_supplier {
          name
          logo
          directories {
            id
            logo
          }
        }

        dental_practice {
          name
          logo
          directories {
            id
            logo
          }
        }

        dental_professional {
          name
          profile_image
          directories {
            id
            profile_image
          }
        }

        admin_user {
          name
          profile_image
        }

        newsfeed {
          id
        }
        jobs {
          id
        }
      }

      news_feeds_comments_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`;

// export const getCatalogueFeedsCount = gql`
//   query GetCatalogueFeedsCount($where: newsfeeds_bool_exp!) {
//     newsfeeds_aggregate(where: $where) {
//       aggregate {
//         count
//       }
//     }
//   }
// `;
export const getCatalogueFeedsCount = gql`
  query GetFilterFeedsCount($where: newsfeeds_bool_exp!) {
    newsfeeds_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`;


/// getJobsByFeedStatus.ts
export const getJobsByFeedStatus = gql`
  query getJobsByFeedStatus($where: jobs_bool_exp!, $limit: Int, $offset: Int) {
    jobs(
      where: $where
      order_by: { updated_at: desc }
      limit: $limit
      offset: $offset
    ) {
      id
      title
      j_type
      community_id
      j_role
      feed_type
      description
      active_status_feed
      TypeofEmployment
      created_at
      updated_at
      location
      banner_image
      dental_supplier {
        id
        logo
        email
        phone
        name
        type
        business_name
        directories {
          id
          company_name
          logo
          description
        }
      }

       dental_practice {
          id
          name
          logo
          type
          business_name
          profession_type
           directories {
              id
              logo
            }
        }

      newsfeeds_likes {
        dental_admin_id
        admin_user {
          id
          name
        }
        dental_practice {
          id
          name
          logo
          type
          profession_type
           directories {
              id
              logo
            }
        }

        dental_supplier {
          id
          name
          logo
          type
          profession_type
           directories {
              id
              logo
            }
        }

        dental_professional {
          id
          name
          profession_type
          type
          profile_image
           directories {
              id
              logo
            }
        }
      }

      newsfeeds_likes_aggregate {
        aggregate {
          count
        }
      }

      news_feeds_comments(order_by: { created_at: desc }) {
        id
        comments
        created_at
        dental_admin_id
        comment_Pro_Img
        commenter_name
        comments_attachments

        comment_reply {
          id
          reply_text
          comment_id
          created_at
          reply_id
          reply_attachments
          dental_admin_id
          dental_practice_id
          dental_professional_id
          dental_supplier_id
          dental_supplier {
            name
            logo
            directories {
              id
              logo
            }
          }
          dental_practice {
            name
            logo
            directories {
              id
              logo
            }
          }
          dental_professional {
            name
            profile_image
            directories {
              id
              profile_image
            }
          }
          admin_user {
            name
            profile_image
          }

          newsfeeds {
            id
          }

          jobs {
            id
          }

          courses{
          id
          }
        }

        dental_practice_id
        dental_professional_id
        dental_supplier_id
        dental_supplier {
          name
          logo
          directories {
            id
            logo
          }
        }
        dental_practice {
          name
          logo
          directories {
            id
            logo
          }
        }
        dental_professional {
          name
          profile_image
          directories {
            id
            profile_image
          }
        }
        admin_user {
          name
          profile_image
        }

        newsfeed {
          id
        }

        jobs {
          id
        }
          courses{
          id
          }
      }

      news_feeds_comments_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`;

// export const getNewsfeedAndJobsCount = gql`

// query getAllCounts {
//   pendingNews: newsfeeds_aggregate(where: { status: { _eq: "PENDING" } }) {
//     aggregate {
//       count
//     }
//   }
//   publishedNews: newsfeeds_aggregate(where: { status: { _eq: "PUBLISHED" } }) {
//     aggregate {
//       count
//     }
//   }
//   unpublishedNews: newsfeeds_aggregate(where: { status: { _eq: "UNPUBLISHED" } }) {
//     aggregate {
//       count
//     }
//   }

//   pendingJobs: jobs_aggregate(
//     where: {
//       status: { _eq: "APPROVE" }
//       active_status: { _eq: "ACTIVE" }
//       active_status_feed: { _eq: "PENDING" }
//     }
//   ) {
//     aggregate {
//       count
//     }
//   }

//   publishedJobs: jobs_aggregate(
//     where: {
//       status: { _eq: "APPROVE" }
//       active_status: { _eq: "ACTIVE" }
//       active_status_feed: { _eq: "PUBLISHED" }
//     }
//   ) {
//     aggregate {
//       count
//     }
//   }

//   unpublishedJobs: jobs_aggregate(
//     where: {
//       status: { _eq: "APPROVE" }
//       active_status: { _eq: "ACTIVE" }
//       active_status_feed: { _eq: "UNPUBLISHED" }
//     }
//   ) {
//     aggregate {
//       count
//     }
//   }
//   pendingLearnhub: courses_aggregate(
//     where: {
//       status: { _eq: "APPROVE" }
//       active_status: { _eq: "ACTIVE" }
//       active_status_feed: { _eq: "PENDING" }
//     }
//   ) {
//     aggregate {
//       count
//     }
//   }

//   publishedLearnhub: courses_aggregate(
//     where: {
//       status: { _eq: "APPROVE" }
//       active_status: { _eq: "ACTIVE" }
//       active_status_feed: { _eq: "PUBLISHED" }
//     }
//   ) {
//     aggregate {
//       count
//     }
//   }

//   unpublishedLearnhub: courses_aggregate(
//     where: {
//       status: { _eq: "APPROVE" }
//       active_status: { _eq: "ACTIVE" }
//       active_status_feed: { _eq: "UNPUBLISHED" }
//     }
//   ) {
//     aggregate {
//       count
//     }
//   }
// }

// `;

// new count 
export const getNewsfeedAndJobsCount = gql`

query getAllCounts($where: newsfeeds_bool_exp!) {
  pendingNews: newsfeeds_aggregate(where: { _and: [{ status: { _eq: "PENDING" } }, $where] }) {
    aggregate {
      count
    }
  }
  publishedNews: newsfeeds_aggregate(where: { _and: [{ status: { _eq: "PUBLISHED" } }, $where ] }  ) {
    aggregate {
      count
    }
  }
  unpublishedNews: newsfeeds_aggregate(where: { _and: [{ status: { _eq: "UNPUBLISHED" } }, $where] }) {
    aggregate {
      count
    }
  }

}

`;


export const updateJobStatusMutation = gql`
  mutation UpdateJobStatus($id: uuid!, $active_status_feed: String!) {
    update_jobs_by_pk(pk_columns: { id: $id }, _set: { active_status_feed: $active_status_feed }) {
      id
      active_status_feed
    }
  }
`;
export const updateLaerninghubMutation = gql`
  mutation updateLaerninghub($id: uuid!, $active_status_feed: String!) {
    update_courses_by_pk(pk_columns: { id: $id }, _set: { active_status_feed: $active_status_feed }) {
      id
      active_status_feed
    }
  }
`;


export const getNewsfeedIdDatajobs = gql`
  query getAllNewsfeedsjobs($id: uuid!) {
    jobs(where: { id: { _eq: $id } }) {
      id
      feed_type
      active_status_feed
      created_at

      dental_supplier {
        id
        logo
        email
        phone
        name
        type
        directories {
          id
       
        }
      }

      news_feeds_comments {
        id
        comments
        created_at
        dental_admin_id
        comment_Pro_Img
        commenter_name
        comments_attachments

        comment_reply {
          id
          reply_text
          comment_id
          created_at
          reply_id
          reply_attachments
          dental_admin_id
          dental_practice_id
          dental_professional_id
          dental_supplier_id
          dental_supplier {
            name
            logo
            directories {
              id
              logo
            }
          }
          dental_practice {
            name
            logo
            directories {
              id
              logo
            }
          }
          dental_professional {
            name
            profile_image
            directories {
              id
              profile_image
            }
          }
          admin_user {
            id
            name
            profile_image
          }

          newsfeeds {
            id
          }

          jobs {
            id
          }

          courses {
            id
          }
        }

        dental_practice_id
        dental_professional_id
        dental_supplier_id
        dental_supplier {
          name
          logo
          directories {
            id
            logo
          }
        }
        dental_practice {
          name
          logo
          directories {
            id
            logo
          }
        }
        dental_professional {
          name
          profile_image
          directories {
            id
            profile_image
          }
        }
        admin_user {
          id
          name
          profile_image
        }

        newsfeed {
          id
        }

        jobs {
          id
        }
          courses{
          id
          }
      }

      news_feeds_comments_aggregate {
        aggregate {
          count
        }
      }

      newsfeeds_likes {
        dental_admin_id
        admin_user {
          id
          name
        }
        dental_practice {
          id
          name
          logo
          type
          profession_type
           directories {
              id
              logo
            }
        }

        dental_supplier {
          id
          name
          logo
          type
          profession_type
           directories {
              id
              logo
            }
        }

        dental_professional {
          id
          name
          profession_type
          type
          profile_image
           directories {
              id
              logo
            }
        }
      }

      newsfeeds_likes_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`;


// get learninghub comments

export const getNewsfeedIdDataCourses = gql`
  query getAllNewsfeedsCourses($id: uuid!) {
    courses(where: { id: { _eq: $id } }) {
      id
      feed_type

      dental_supplier {
        id
        logo
        email
        phone
        name
        type
        directories {
          id
          company_name
          logo
          description
        }
      }

      news_feeds_comments {
        id
        comments
        created_at
        dental_admin_id
        comment_Pro_Img
        commenter_name
        comments_attachments

        comment_reply {
          id
          reply_text
          comment_id
          created_at
          reply_id
          reply_attachments
          dental_admin_id
          dental_practice_id
          dental_professional_id
          dental_supplier_id
          dental_supplier {
            name
            logo
            directories {
              id
              logo
            }
          }
          dental_practice {
            name
            logo
            directories {
              id
              logo
            }
          }
          dental_professional {
            name
            profile_image
            directories {
              id
              profile_image
            }
          }
          admin_user {
            id
            name
            profile_image
          }

          newsfeeds {
            id
          }

          jobs {
            id
          }

          courses {
            id
          }
        }

        dental_practice_id
        dental_professional_id
        dental_supplier_id
        dental_supplier {
          name
          logo
          directories {
            id
            logo
          }
        }
        dental_practice {
          name
          logo
          directories {
            id
            logo
          }
        }
        dental_professional {
          name
          profile_image
          directories {
            id
            profile_image
          }
        }
        admin_user {
          id
          name
          profile_image
        }

        newsfeed {
          id
        }

        jobs {
          id
        }

        courses {
          id
        }
      }

      news_feeds_comments_aggregate {
        aggregate {
          count
        }
      }

      newsfeeds_likes {
        dental_admin_id
        admin_user {
          id
          name
        }
        dental_practice {
          id
          name
          logo
          type
          profession_type
           directories {
              id
              logo
            }
        }

        dental_supplier {
          id
          name
          logo
          type
          profession_type
           directories {
              id
              logo
            }
        }

        dental_professional {
          id
          name
          profession_type
          type
          profile_image
           directories {
              id
              logo
            }
        }
      }

      newsfeeds_likes_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`;

// learninghub

export const getLearningHub = gql`
 query getLearningHub($where: courses_bool_exp!, $limit: Int, $offset: Int) {
    courses(
      where: $where
      order_by: { updated_at: desc }
      limit: $limit
      offset: $offset
    ) {
      id
      updated_at
      created_at
      community_id
      status
      active_status
      active_status_feed
      feed_type
      type
      created_by_id
      presented_by_name
      address
      user_role
      course_banner_video
      course_banner_image
      description
      cpd_points
      dental_supplier {
        id
        logo
        email
        phone
        name
        type
        business_name
        directories {
          id
          company_name
          logo
          description
        }
      }
      dental_Admin {
       id
       name
      }

            newsfeeds_likes {
        dental_admin_id
        admin_user {
          id
          name
        }
        dental_practice {
          id
          name
          logo
          type
          profession_type
           directories {
              id
              logo
            }
        }

        dental_supplier {
          id
          name
          logo
          type
          profession_type
           directories {
              id
              logo
            }
        }

        dental_professional {
          id
          name
          profession_type
          type
          profile_image
           directories {
              id
              logo
            }
        }
      }

      newsfeeds_likes_aggregate {
        aggregate {
          count
        }
      }

      news_feeds_comments(order_by: { created_at: desc }) {
        id
        comments
        created_at
        dental_admin_id
        comment_Pro_Img
        commenter_name
        comments_attachments

        comment_reply {
          id
          reply_text
          comment_id
          created_at
          reply_id
          reply_attachments
          dental_admin_id
          dental_practice_id
          dental_professional_id
          dental_supplier_id
          dental_supplier {
            name
            logo
            directories {
              id
              logo
            }
          }
          dental_practice {
            name
            logo
            directories {
              id
              logo
            }
          }
          dental_professional {
            name
            profile_image
            directories {
              id
              profile_image
            }
          }
          admin_user {
            name
            profile_image
          }

           newsfeeds {
            id
          }

          jobs {
            id
          }
            courses{
            id
            }
        }

        dental_practice_id
        dental_professional_id
        dental_supplier_id
        dental_supplier {
          name
          logo
          directories {
            id
            logo
          }
        }
        dental_practice {
          name
          logo
          directories {
            id
            logo
          }
        }
        dental_professional {
          name
          profile_image
          directories {
            id
            profile_image
          }
        }
        admin_user {
          name
          profile_image
        }

         newsfeed {
            id
          }

          jobs {
            id
          }

          courses{
            id
            }
      }

      news_feeds_comments_aggregate {
        aggregate {
          count
        }
      }

    }
}
      
`;


export const getCataloguesByIds = gql`
  query GetCataloguesByIds($ids: [uuid!]!) {
    catalogues(where: { id: { _in: $ids } }) {
      id
      expiryDay
      catalogue_category{
      name
     }
      catalogue_sub_category{
       name
      }
    }
  }
`;


export const GET_FEED_BY_ID = gql`
query GetFeedByPayload($id: uuid!) {
 newsfeeds(where: { 
    _or: [
      { id: { _eq: $id } },
      { payload_id: { _eq: $id } }
    ] 
  }) {
    id
    feed_type
    title
    description
    created_at
    active_status
    payload_id
    post_image
      web_url
      video_url
      user_role
      user_id
      dental_practice_id
      dental_professional_id
      dental_supplier_id
      dental_admin_id
        dental_supplier {
        id
        logo
        email
        phone
        name
        directories {
          company_name
          logo
          
        }
      }  
        dental_practice {
        id
        logo
        email
        phone
        name
        directories {
          company_name
          logo
          
        }
      }  
        dental_professional {
        id
        email
        phone
        name
        directories {
          company_name
          logo
          
        }
      }  
        admin_user{
      id
      name  
      }
  
    catalogues{
      id
      created_at
      attachment
      title
      catalogue_category{
      name
      }
      catalogue_sub_category{
      name
      }
    }

    courses {
        id
      created_at
      type
      created_by_id
      presented_by_name
      address
      course_banner_video
      course_banner_image
      cpd_points
    }

    jobs {
      id
      j_type
      j_role
      TypeofEmployment
      created_at
      location
      banner_image
    }
  }
}
`;

export const SUPPLIER_COMMUNITY_FEEDS_COUNT = gql`
  query SupplierCommunityFeedsCount($where: newsfeeds_bool_exp!) {
    newsfeeds_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

export const getCommunityMembersCount = gql`
  query GetCommunityMembersCount($where: community_members_bool_exp) {
    community_members(where: $where, limit: 1) {
      dental_suppliers{
      business_name}
    }
    community_members_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`;


// new implemented

export const getAllNewsfeedsAll = gql`
  query getAllNewsfeeds(
    $where: newsfeeds_bool_exp!
    $limit: Int
    $offset: Int
    $userId: uuid
    $roleType: String
  ) {
    newsfeeds(
      where: $where
      order_by: { created_at: desc }
      limit: $limit
      offset: $offset
    ) {
      id
      created_at
      updated_at
      post_image
      community_id
      description
      category_type
      attachments
      feed_type
      payload
      user_role
      video_url
      web_url
      user_id
      status
      title
      dental_practice_id
      dental_professional_id
      dental_supplier_id
      dental_admin_id
      dental_supplier {
        id
        logo
        business_name
        profession_type
        email
        phone
        name
        type
        directories {
          id
          company_name
          logo
          description
          banner_image
        }
      }
      dental_professional {
        id
        name
        profession_type
        profile_image
        email
        phone
        type
      }

      dental_practice {
        id
        logo
        business_name
        profession_type
        email
        phone
        name
        type
        directories {
          company_name
          logo
          description
          banner_image
        }
      }
      admin_user {
        id
        phone
        email
      }

      courses {
        id
        presenters
        address
        cpd_points
        type
        course_banner_image
      }
      catalogues {
        id
        schedulerDay
      }
      jobs {
        id
        banner_image
        j_role
        location
        TypeofEmployment
      }

      newsfeeds_likes {
      id
        dental_admin_id
        admin_user {
          id
          name
        }

        dental_practice {
          business_name
          directories {
            id
          }
        }

        dental_supplier {
          business_name
          directories {
            id
          }
        }

        dental_professional {
          name
          directories {
            id
          }
        }
      }

      my_like: newsfeeds_likes(
        where: {
          role_type: { _eq: $roleType }
          _or: [
            { dental_supplier_id: { _eq: $userId } }
            { dental_practice_id: { _eq: $userId } }
            { dental_professional_id: { _eq: $userId } }
            { dental_admin_id: { _eq: $userId } }
          ]
        }
      ) {
        id
      }

      newsfeeds_likes_aggregate {
        aggregate {
          count
        }
      }

      news_feeds_comments(order_by: { created_at: desc }) {
        id
        comments
        created_at
        updated_at
        dental_admin_id
        comment_Pro_Img
        commenter_name
        comments_attachments

        comment_reply {
          id
          reply_text
          comment_id
          created_at
          reply_id
          reply_attachments
          dental_admin_id
          dental_practice_id
          dental_professional_id
          dental_supplier_id
          dental_supplier {
            name
            logo
            business_name
            directories {
              id
              logo
            }
          }
          dental_practice {
            name
            logo
            business_name
            directories {
              id
              logo
            }
          }
          dental_professional {
            name
            profile_image
            directories {
              id
              profile_image
            }
          }
          admin_user {
            name
            profile_image
          }

          newsfeeds {
            id
          }

          jobs {
            id
          }
          courses {
            id
          }
        }
        dental_practice_id
        dental_professional_id
        dental_supplier_id
        dental_supplier {
          name
          logo
          business_name
          directories {
            id
            logo
          }
        }
        dental_practice {
          name
          logo
          business_name
          directories {
            id
            logo
          }
        }
        dental_professional {
          name
          profile_image
          directories {
            id
            profile_image
          }
        }
        admin_user {
          name
          profile_image
        }

        newsfeed {
          id
        }

        jobs {
          id
        }
        courses {
          id
        }
      }

      news_feeds_comments_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`;